import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=36b8ac85&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=ts"
export * from "./TheSidebar.vue?vue&type=script&lang=ts"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=36b8ac85&prod&lang=css"
import style1 from "./TheSidebar.vue?vue&type=style&index=1&id=36b8ac85&prod&scoped=true&lang=css"
import style2 from "./TheSidebar.vue?vue&type=style&index=2&id=36b8ac85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8ac85",
  null
  
)

export default component.exports